/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_violin_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One numeric column per group, optionally with a header row of group names. Each column is summarised into its own violin.`)
};

const es_violin_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una columna numérica por grupo, opcionalmente con una fila de encabezado con los nombres de los grupos. Cada columna se resume en su propio violín.`)
};

const de_violin_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine numerische Spalte pro Gruppe, optional mit einer Kopfzeile mit Gruppennamen. Jede Spalte wird zu einer eigenen Violine zusammengefasst.`)
};

const nl_violin_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eén numerieke kolom per groep, optioneel met een koprij van groepsnamen. Elke kolom wordt samengevat in zijn eigen viool.`)
};

const fr_violin_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une colonne numérique par groupe, éventuellement avec une ligne d'en-tête de noms de groupes. Chaque colonne est résumée dans son propre violon.`)
};

const it_violin_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una colonna numerica per gruppo, facoltativamente con una riga di intestazione con i nomi dei gruppi. Ogni colonna viene riassunta nel proprio violino.`)
};

const pt_br2_violin_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma coluna numérica por grupo, opcionalmente com uma linha de cabeçalho com os nomes dos grupos. Cada coluna é resumida em seu próprio violino.`)
};

const pt_violin_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma coluna numérica por grupo, opcionalmente com uma linha de cabeçalho com os nomes dos grupos. Cada coluna é resumida no seu próprio violino.`)
};

const ja_violin_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループごとに1つの数値列で、任意でグループ名のヘッダー行を付けられます。各列はそれぞれ1つのバイオリンに要約されます。`)
};

const zh_violin_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每组一列数值数据，可选带有组名的表头行。每一列都会被汇总为一个独立的小提琴。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const violin_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.violin_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("violin_faq_a4", locale)
	if (locale === "en") return en_violin_faq_a4(inputs)
	if (locale === "es") return es_violin_faq_a4(inputs)
	if (locale === "de") return de_violin_faq_a4(inputs)
	if (locale === "nl") return nl_violin_faq_a4(inputs)
	if (locale === "fr") return fr_violin_faq_a4(inputs)
	if (locale === "it") return it_violin_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_violin_faq_a4(inputs)
	if (locale === "pt") return pt_violin_faq_a4(inputs)
	if (locale === "ja") return ja_violin_faq_a4(inputs)
	return zh_violin_faq_a4(inputs)
};